<div class="ov column">
  Nº
</div>
<div class="timestamp column">
  Data/Hora de Entrada
</div>
<div class="products column">
  Produtos
</div>
<div class="quantity column">
  Qtd
</div>
<div class="status column">
  Status
</div>
<div class="buttons column"></div>